var _desc, _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24.123047,
    height: 24.487061,
    viewBox: "0 0 24.123 24.4871",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path 384",
    d: "M23.99 10.01L12.3 10.01L12.3 15.02L18.92 15.02C17.86 18.36 15.25 19.47 12.24 19.47C9.04 19.48 6.22 17.38 5.3 14.32C4.38 11.25 5.58 7.95 8.26 6.19C10.93 4.43 14.44 4.64 16.89 6.7L20.53 3.23C16.5 -0.48 10.49 -1.06 5.82 1.81C1.16 4.68 -1.03 10.3 0.46 15.57C1.95 20.85 6.76 24.48 12.24 24.48C19 24.48 25.1 20.03 23.99 10.01Z",
    fill: "#FFFFFF",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path 384",
    d: "M12.3 10.01L12.3 15.02L18.92 15.02C17.86 18.36 15.25 19.47 12.24 19.47C9.04 19.48 6.22 17.38 5.3 14.32C4.38 11.25 5.58 7.95 8.26 6.19C10.93 4.43 14.44 4.64 16.89 6.7L20.53 3.23C16.5 -0.48 10.49 -1.06 5.82 1.81C1.16 4.68 -1.03 10.3 0.46 15.57C1.95 20.85 6.76 24.48 12.24 24.48C19 24.48 25.1 20.03 23.99 10.01L12.3 10.01Z",
    stroke: "#707070",
    strokeOpacity: 0,
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleWhite);
export default __webpack_public_path__ + "static/media/google_white.efb3db6c312fbeb3ad4842cf81d9b2a3.svg";
export { ForwardRef as ReactComponent };